var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooks = function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.4 398.3L320 268.3V142.8l93.7-25.1 67.2 247L355.4 398.3zM405.3 86.8L320 109.6V16.3L381.7 0l23.6 86.8zM363.8 429.2l125.5-33.6L512 478.9 386.3 512l-22.5-82.8zM0 0H128V96H0V0zM0 128H128V384H0V128zM0 416H128v96H0V416zM160 0H288V96H160V0zm0 128H288V384H160V128zm0 288H288v96H160V416z"
  })));
};
export default SvgBooks;